import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../../CacheDataRoute';
import BarMenuPublicCategories from '@routes/BarMenu/stages/BarMenuPublicCategories';

export const Route = createFileRoute('/barmenu/$barId/')({
  staticData: {
    layout: {
      path: '/barmenu/:barId',
      withoutHeader: true,
      withoutFooter: true
    }
  },
  component: () => (
    <CacheDataRoute
      component={BarMenuPublicCategories}
      path='/barmenu/:barId'
    />
  )
});
